import { isEmpty, exceedsLimit } from '../../../../helpers/Validation/validationHelpers';
import messages from '../../../../locale/jsonMessages';

const validate = (values, props) => {
  const errors = {};
  const activeLanguageCodes = props?.activeLanguageCodes || [];

  if (isEmpty(values?.code)) {
    errors.code = messages.required;
  } else if (exceedsLimit(values?.code, 15)) {
    errors.code = messages.promoDiscountRestriction;
  }

  if (isEmpty(values?.promoValue)) {
    errors.promoValue = messages.required;
  } else if (values?.promoValue) {
    if (
      isNaN(values?.promoValue) ||
      !/^[0-9\.]+$/.test(values?.promoValue) ||
      parseInt(values?.promoValue, 10) < 0 ||
      parseInt(values?.promoValue, 10) > 99
    ) {
      errors.promoValue = messages.promoDiscountInvalid;
    }
  }

  if (values?.dynamicPromoCode && values.dynamicPromoCode.length > 0) {
    const dynamicPromoCodeErrors = values.dynamicPromoCode.map((promoItem) => {
      const itemErrors = {};
      const isLanguageInactive = promoItem?.language && activeLanguageCodes.length > 0
        && !activeLanguageCodes.includes(promoItem.language);

      if (!promoItem || isEmpty(promoItem?.language || isLanguageInactive)) {
        itemErrors.language = messages.required;
      }

      if (!promoItem || isEmpty(promoItem?.title)) {
        itemErrors.title = messages.required;
      } else if (exceedsLimit(promoItem?.title, 50)) {
        itemErrors.title = messages.codeRestriction;
      }

      if (!promoItem || isEmpty(promoItem?.description)) {
        itemErrors.description = messages.required;
      } else if (exceedsLimit(promoItem?.description, 250)) {
        itemErrors.description = messages.couponRestrictionLimit;
      }

      return itemErrors;
    });

    // Only attach if at least one entry has an error
    if (dynamicPromoCodeErrors.some((itemErrors) => Object.keys(itemErrors).length > 0)) {
      errors.dynamicPromoCode = dynamicPromoCodeErrors;
    }
  }

  return errors;
};

export default validate;